let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1EqDq")).then(() => parcelRequire('10zD8'));